import { z } from "zod";
import { isValidLuhn } from "@/utils/cardUtils";

export const CreditCardSchema = z.object({
  holderName: z
    .string()
    .min(1, "Nome do titular é obrigatório.")
    .transform((val) => val.trim().replace(/\s+/g, " "))
    .refine((val) => {
      const words = val.split(" ").filter(Boolean);
      return words.length >= 2;
    }, "Informe o nome completo (mínimo duas palavras).")
    .refine(
      (val) => /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(val),
      "Nome do titular inválido.",
    ),
  number: z
    .string()
    .min(1, "Número do cartão é obrigatório.")
    .regex(/^[\d\s]+$/, "Somente números são permitidos.")
    .refine((val) => {
      const clean = val.replace(/\s/g, "");
      return clean.length >= 13 && clean.length <= 19;
    }, "Número do cartão inválido.")
    .refine(
      (val) => isValidLuhn(val.replace(/\s/g, "")),
      "Número do cartão inválido.",
    ),
  expiryMonth: z.string().min(1, "Mês de expiração é obrigatório."),
  expiryYear: z.string().min(1, "Ano de expiração é obrigatório."),
  ccv: z.string().min(1, "CVV é obrigatório."),
});

export const CreditCardHolderInfoSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório."),
  email: z.string().email("E-mail inválido."),
  cpfCnpj: z.string().min(1, "CPF/CNPJ é obrigatório."),
  postalCode: z.string().min(1, "CEP é obrigatório."),
  addressNumber: z.string().min(1, "Número do endereço é obrigatório."),
  phone: z.string().min(1, "Telefone é obrigatório."),
});

export const CreditCardBrandSchema = z.enum([
  "VISA",
  "MASTERCARD",
  "ELO",
  "DINERS",
  "DISCOVER",
  "AMEX",
  "CABAL",
  "BANESCARD",
  "CREDZ",
  "SOROCRED",
  "CREDSYSTEM",
  "JCB",
  "UNKNOWN",
]);

export const CreditCardInfoSchema = z.object({
  creditCardBrand: CreditCardBrandSchema,
  creditCardNumber: z.string(),
  creditCardToken: z.string(),
});

export type CreditCardInfo = z.infer<typeof CreditCardInfoSchema>;

export type CreditCardBrand = z.infer<typeof CreditCardBrandSchema>;

export type CreditCardDTO = z.infer<typeof CreditCardSchema>;
export type CreditCardHolderInfoDTO = z.infer<
  typeof CreditCardHolderInfoSchema
>;
